import React from 'react';
import './HomeContent.css'
import { Link } from "react-router-dom"
import Button from '../Button/Button';


function HomeContent() {
  return (
    <div className='homecontent'>
        <div className='homecontent_inner'>
            <div className='homecontent_text'>
                <h1>PROVIDUS CORPORATE ACCOUNT OPENING</h1>
                 <span>Business Account Opening is an initiative that will provide access to support services - Legal practitioners, SME Specialists bookkeeping personnel relationship manager risk assessment evaluations and more 
                     <p>This initiative recognises that SMEs do not necessarily require facilities and may need other services from the bank. Business Account Opening will involve a widespread of businesses from different sectors. This will include an initial analysis of their business strengths, weaknesses, opportunities and threats which will enable SMEs to prosper in the changing business environment.</p>
                 </span>
                 <Link to ="/createaccount">
                    <Button content= "Continue"/>
                </Link>
            </div>
        </div>
    </div>
  );
}

export default HomeContent;
